var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ckeditor" }, [
    _c("textarea", {
      attrs: { id: _vm.uid, ckheight: _vm.height, ckwidth: _vm.width },
      domProps: { value: _vm.internalValue }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }